export const ROUTES = {
	HOME: '/',
	DASHBOARD: '/',
	BRD: '/brd',
	LOGIN: '/sign-in',
	SIGNUP: '/sign-up',
	RESET_PASSWORD: '/reset-password',
	CREATE_NEW_PASSWORD: '/reset-password/new',
	PAYMENT_SUCCESS: '/payment-success',
	PAYMENT_CANCEL: '/payment-cancel',
	METHOD_SUCCESS: '/method-success',
	//METHOD_CANCEL: '/method-cancel',
	METHOD_CANCEL: '/brd',
	SETTINGS: '/settings',
	SETTINGS_PROFILE: '/settings/profile',
	SETTINGS_SUBSCRIPTION: '/settings/subscription',
	SETTINGS_DOCS: '/settings/docs',
	SETTINGS_MODEL: '/settings/model',
	SUPPORT: '/support',
	PROJECTS: '/projects',
	NOTIFICATIONS: '/notifications',
};
